import { Skeleton } from "@chakra-ui/react";
export function SliderLoading(): JSX.Element {
  return <Skeleton height="400px" />;
}
